import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { IconArrowDown, IconArrowUp } from '@sfx/icons';
import { IconMenuDown, IconMenuUp, IconFilterMenuDown, IconFilterMenuUp } from '@sfx/icons';
import { SearchInput } from '../../../Input';
import { getTransFunc } from '../../../SFxLocalization';
var prefix = 'sfx-react-ui';

var SFxFilterDropdown = function SFxFilterDropdown(props) {
  var trans = getTransFunc(props.transInstance) || getTransFunc();
  var filtered = props.filtered,
      columnID = props.id,
      sortTextAsc = props.sortTextAsc,
      sortTextDesc = props.sortTextDesc;

  var _useState = useState({
    dropdownOpen: false,
    searchText: filtered && columnID && filtered.find(function (item) {
      return item.id === columnID;
    }) && filtered.find(function (item) {
      return item.id === columnID;
    }).value || "",
    manualFilterData: [],
    sortable: !!props.sortable,
    filterable: !!props.filterable
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      sortable: !!props.sortable,
      filterable: !!props.filterable
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.sortable, props.filterable]);

  var toggle = function toggle() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      dropdownOpen: !state.dropdownOpen
    }));
  };

  var sortChange = function sortChange(id, desc) {
    var sorter = sorted.find(function (sort) {
      return sort.id === id;
    });

    if (sorter) {
      if (sorter.desc === desc) {
        props.setSorted(id, null);
      } else {
        props.setSorted(id, desc);
      }
    } else {
      props.setSorted(id, desc);
    }
  };

  var setSearchText = function setSearchText(e) {
    var value = e.target.value;

    if (value === 0) {
      value = '0';
    } else {
      value = value && String(value);
    }

    var onSearchCntChange = props.onSearchCntChange,
        id = props.id;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      searchText: value
    }));
    onSearchCntChange && onSearchCntChange({
      id: id,
      value: value,
      manualSearch: true
    });
  };

  var onFilterChange = function onFilterChange(value, manualSearch) {
    var onSearchCntChange = props.onSearchCntChange,
        id = props.id;
    onSearchCntChange && onSearchCntChange({
      id: id,
      value: value,
      manualSearch: manualSearch
    });
  };

  if (state.sortable === false && state.filterable === false || props.data.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  var stopPop = function stopPop(e) {
    e.stopPropagation();
  };

  var hasFilterChecked = function hasFilterChecked() {
    var filterChecked = false;
    var filtered = props.filtered,
        id = props.id;

    if (filtered && filtered.length > 0) {
      var target = filtered.find(function (elem) {
        return elem.id === id;
      });

      if (target) {
        filterChecked = true;
      }
    }

    return filterChecked;
  };

  var CustomSorter = props.Sorter,
      sorted = props.sorted,
      relatedIds = props.relatedIds,
      id = props.id,
      CustomFilter = props.Filter;

  var getCheckedSorterId = function getCheckedSorterId() {
    if (sorted.length) {
      if (sorted[0].desc === true) {
        return "".concat(sorted[0].id, "-desc");
      } else if (sorted[0].desc === false) {
        return "".concat(sorted[0].id, "-asc");
      }
    }

    return '';
  };

  var groupColumnIds = relatedIds && [id].concat(_toConsumableArray(relatedIds));
  var customSorterProps = {
    groupColumnIds: groupColumnIds,
    getCheckedSorterId: getCheckedSorterId,
    sortChange: sortChange
  };
  var checkedSorterId = getCheckedSorterId();
  return /*#__PURE__*/React.createElement(Dropdown, {
    isOpen: state.dropdownOpen,
    toggle: toggle,
    className: "".concat(prefix, "-Dropdown"),
    onClick: stopPop
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    tag: "span",
    onClick: toggle,
    "data-toggle": "dropdown",
    "aria-expanded": state.dropdownOpen,
    className: "".concat(state.dropdownOpen ? "dropdownOpen" : "", " dropDownToggle")
  }, props.showFilterIcon && hasFilterChecked() ? /*#__PURE__*/React.createElement(React.Fragment, null, state.dropdownOpen ? /*#__PURE__*/React.createElement(IconFilterMenuUp, {
    size: 16
  }) : /*#__PURE__*/React.createElement(IconFilterMenuDown, {
    size: 16
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, state.dropdownOpen ? /*#__PURE__*/React.createElement(IconMenuUp, null) : /*#__PURE__*/React.createElement(IconMenuDown, null))), /*#__PURE__*/React.createElement(DropdownMenu, null, /*#__PURE__*/React.createElement("div", {
    className: "dropdownMenu"
  }, state.sortable && /*#__PURE__*/React.createElement(React.Fragment, null, CustomSorter ? /*#__PURE__*/React.createElement(CustomSorter, customSorterProps) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dropdownSort"
  }, /*#__PURE__*/React.createElement("label", {
    className: "virtualChk"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "".concat(props.id, "Sort"),
    id: "".concat(props.id, "-asc"),
    checked: checkedSorterId === "".concat(props.id, "-asc"),
    onClick: function onClick() {
      return sortChange(props.id, false);
    },
    onChange: function onChange() {
      return sortChange(props.id, false);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "".concat(props.id, "-asc")
  }), /*#__PURE__*/React.createElement("span", {
    className: "optionLabel"
  }, sortTextAsc || trans("SFxTableViewSortA_Z"), /*#__PURE__*/React.createElement(IconArrowUp, {
    className: "img-arrow"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "dropdownSort"
  }, /*#__PURE__*/React.createElement("label", {
    className: "virtualChk"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "".concat(props.id, "Sort"),
    id: "".concat(props.id, "-desc"),
    checked: checkedSorterId === "".concat(props.id, "-desc"),
    onClick: function onClick() {
      return sortChange(props.id, true);
    },
    onChange: function onChange() {
      return sortChange(props.id, true);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "".concat(props.id, "-desc")
  }), /*#__PURE__*/React.createElement("span", {
    className: "optionLabel"
  }, sortTextDesc || trans("SFxTableViewSortZ_A"), /*#__PURE__*/React.createElement(IconArrowDown, {
    className: "img-arrow"
  })))))), state.filterable && /*#__PURE__*/React.createElement("div", {
    className: "filter-container"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, CustomFilter ? /*#__PURE__*/React.createElement(CustomFilter, {
    filtered: filtered,
    onFilterChange: onFilterChange,
    onSearch: props.onFilter
  }) : /*#__PURE__*/React.createElement(SearchInput, {
    type: "search",
    className: "border-0 outline-0",
    onChange: setSearchText,
    value: state.searchText,
    onSearchClick: props.onFilter
  }))))));
};

export default SFxFilterDropdown;